import React from "react";
import Select from 'react-select';

interface CommonOption {
  label: string;
  value: string;
  [key: string]: any; // allows extra fields
}

interface AsyncPaginateSelectProps {
  name: string;
  onChange: (option: CommonOption | null) => void;
  placeholder?: string;
  isSearchable?: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
  className?: string;
  options: CommonOption[];
  isClearable?: boolean;
  value?: CommonOption | null;
  onBlur?: () => void;
  inputId?: string;
}

export const ReactSelectInput: React.FC<AsyncPaginateSelectProps> = ({
  name,
  onChange,
  placeholder = "Select...",
  className = "w-full",
  isClearable = true,
  options,
  isSearchable = true,
  isLoading = false,
  isDisabled = false,
  value,
  onBlur,
  inputId,
}) => {
  return (
   <Select
        className={`basic-single ${className} text-black`}
        isDisabled={isDisabled}
        isLoading={isLoading}
        placeholder={placeholder}
        onChange={onChange}
        isClearable={isClearable}
        isSearchable={isSearchable}
        name={name}
        options={options}
        value={value}
        onBlur={onBlur}
        inputId={inputId}
        menuPortalTarget={typeof document !== "undefined" ? document.body : null}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 10050 }),
        }}
      />
  );
};
